import { Currency } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';
import { ICurrencyDictionaryItem } from '@/types';

export const currencyDictionary = createSimpleDictionary<ICurrencyDictionaryItem>([
    { id: Currency.Euro, name: 'dictionaries.currency.euro', symbol: '€' },
    { id: Currency.Gbp, name: 'dictionaries.currency.gbp', symbol: '£' },
    { id: Currency.Yen, name: 'dictionaries.currency.yen', symbol: '¥' },
    { id: Currency.Brl, name: 'dictionaries.currency.brl', symbol: 'R$' },
    { id: Currency.Usd, name: 'dictionaries.currency.usd', symbol: '$' },
    { id: Currency.MalaysianRinggit, name: 'dictionaries.currency.malaysianRinggit', symbol: 'RM' },
    { id: Currency.HongKongDollar, name: 'dictionaries.currency.hongKongDollar', symbol: 'hk$' },
]);
